import { createContext } from 'react';
import type { TabContextType } from './Tabs.types';

export const TabContext = createContext<TabContextType | undefined>(undefined);
